export const updateLifetimeAllowanceSteppersMap = {
    updateLifetimeAllowanceDetail:"Allowance details",
    updateLifetimeAllowanceConfirmation:"Confirmation",
};

export const UpdateLifetimeAllowanceContent = {
    ltaDetails: "Allowance Details",
    ltaPreviouslyCrystallisedOnPlatform:"Lifetime allowance (LTA) previously crystallised on platform",
    ltaUsedByBenefitsThatCommencedPriorToDate:"LTA used by benefits that commenced prior to 06/04/2006",
    ltaCrystallisedOffPlatform:"LTA crystallised off platform not including transfers already made to the platform",
    ltaUsed:"Lifetime allowance used",
    allowanceUsed:"Allowance Used",
    lsaUsedAsAt5April2024Amount:"LSA previously used in this account, as at 5 April 2024",
    lsaUsedOnOrAfter6April2024Amount:"LSA previously used in this account, on or after 6 April 2024",
    lsaUsedBefore6April2006Amount:"LSA used by benefits that commenced before 6 April 2006",
    lsaOtherUsedAsAt5April2024Amount:"Other LSA as at 5 April 2024 you need to tell us about",
    lsaOtherUsedOnOrAfter6April2024Amount:"Other LSA on or after 6 April 2024 you need to tell us about",
    lsdbaUsedLSDBAAsAt5April2024Amount:"LSDBA previously used in this account, as at 5 April 2024",
    lsdbaUsedLSDBAOnOrAfter6April2024Amount:"LSDBA previously used in this account, on or after 6 April 2024",
    lsdbaUsedLSDBABefore6April2006Amount:"LSDBA used by benefits that commenced before 6 April 2006",
    lsdbaOtherLSDBAUsedAsAt5April2024Amount:"Other LSDBA as at 5 April 2024 you need to tell us about",
    isPartOfUsedSIHBefore75:"Was part of this amount used in respect of a Serious Ill Health Lump Sum taken prior to age 75?",
    lsdbaOtherLSDBAUsedOnOrAfter6April2024Amount:"Other LSDBA on or after 6 April 2024 you need to tell us about",
    hasTakenIllHealthLumpSum:"Has a Serious Ill Health Lump Sum previously been taken?",

    messages:{
        percentageOver100:"The total lifetime allowance used must not exceed 100%",
        percentageUnder0: "At least 0%"
    }
}